export default {
  path: '/learning-center',
  component: () => import(/* webpackChunkName: "learning" */ '@/views/learning/LearningCenter.vue'),
};
